'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _Status = require('./Status');

var _Status2 = _interopRequireDefault(_Status);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Api = function () {
  function Api() {
    var _this = this;

    _classCallCheck(this, Api);

    this.convertToJson = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
        var contentType;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                contentType = response.headers.get('content-type');

                if (!(contentType && contentType.indexOf('application/json') !== -1)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', response.json());

              case 3:
                return _context.abrupt('return', response.text());

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    this.fetchApi = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(url, reqObj, shouldCache) {
        var response, statusCode, returnResponse;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch(url, reqObj);

              case 2:
                response = _context2.sent;
                statusCode = response.status;
                _context2.next = 6;
                return _this.convertToJson(response);

              case 6:
                response = _context2.sent;
                returnResponse = {
                  status: statusCode,
                  data: response.Data || response.data,
                  response: response
                };

                if (!(shouldCache && _Status2.default.isSuccess(statusCode))) {
                  _context2.next = 11;
                  break;
                }

                window.localStorage.setItem(url, JSON.stringify(returnResponse));
                return _context2.abrupt('return', returnResponse);

              case 11:
                return _context2.abrupt('return', returnResponse);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();
  }
  /**
   * Convert response to json
   * @private
   * @param {object} response
   * @returns {Promise}
   */


  /**
   * Perform a post request
   * @param {string} url
   * @param {object} body
   * @param {array} reqHeaders
   * @param {boolean} shouldCache
   * @returns {Promise}
   */
  Api.prototype.post = function post(url, body, reqHeaders, shouldCache) {
    return this.makeRequest('post', body, url, reqHeaders, shouldCache);
  };

  /**
   * Perform a put request
   * @param {string} url
   * @param {object} body
   * @param {array} reqHeaders
   * @param {boolean} shouldCache
   * @returns {Promise}
   */


  Api.prototype.put = function put(url, body, reqHeaders, shouldCache) {
    return this.makeRequest('put', body, url, reqHeaders, shouldCache);
  };

  /**
   * Perform a delete request
   * @param {string} url
   * @param {object} body
   * @param {array} reqHeaders
   * @param {boolean} shouldCache
   * @returns {Promise}
   */


  Api.prototype.delete = function _delete(url, reqHeaders, shouldCache) {
    return this.makeRequest('delete', undefined, url, reqHeaders, shouldCache);
  };

  /**
   * Perform a get request
   * @param {string} url
   * @param {array} reqHeaders
   * @param {boolean} shouldCache
   * @returns {Promise}
   */


  Api.prototype.get = function get(url, reqHeaders, shouldCache) {
    return this.makeRequest('get', undefined, url, reqHeaders, shouldCache);
  };

  /**
   * General wrapper for fetch method
   * @private
   * @param {string} type
   * @param {Object} body
   * @param {string} url
   * @param {Array} reqHeaders
   * @param {boolean} shouldCache
   * @returns {Promise}
   */


  Api.prototype.makeRequest = function makeRequest(type, body, url, reqHeaders, shouldCache) {
    var _this2 = this;

    var headers = new Headers();

    if (type !== 'get') {
      headers.append('Content-Type', 'application/json');
    }

    if (reqHeaders) {
      reqHeaders.map(function (header) {
        return headers.append(header.key, header.value);
      });
    }

    var reqObj = {
      method: type,
      headers: headers,
      body: undefined
    };

    if (body) {
      reqObj.body = JSON.stringify(body);
    }

    if (shouldCache) {
      // Check if the browser supports localStorage API
      if (window.localStorage) {
        var responseCache = window.localStorage.getItem(url);

        if (responseCache) {
          return new Promise(function (resolve) {
            resolve(JSON.parse(responseCache));
            _this2.fetchApi(url, reqObj, shouldCache);
          });
        }
      }
    }

    return this.fetchApi(url, reqObj, shouldCache);
  };

  /**
   * Make the actual request
   * @param {string} url
   * @param {Object} reqObj
   * @param {boolean} shouldCache
   * @returns {Object}
   */


  return Api;
}();

exports.default = Api;
module.exports = exports['default'];